import { getCountryCallingCode } from 'libphonenumber-js';
import type { CountryCode } from 'libphonenumber-js/max';

import { getFlagEmoji } from '@/configuration/lang/lang';
import { getAllowedCountries } from '@/stores/countryStore';

export const useCountryCodesPhone = (value?: string) => {
    const countries = getAllowedCountries();
    return countries
        .map(country => ({
            id: country,
            label: `${getFlagEmoji(country as CountryCode)} (${country}) +${getCountryCallingCode(country as CountryCode)}`,
            selected: value === country,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
};
